import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { API_URL } from "@/common/utils/env";

export default function useSlackConnectionUrl(): string {
  const { org, app } = useEnvironment();

  if (!org || !app) {
    return "";
  }

  const redirect = window.location.href.replace(window.location.origin, "");

  const searchParams = {
    appId: app.id,
    appName: app.name,
    redirect,
  };

  return `${API_URL}/orgs/${org.id}/slack/connect?${new URLSearchParams(
    searchParams,
  ).toString()}`;
}
